<template>
  <v-data-table
    :headers="headers"
    :search="search"
    :items="items"
    class="elevation-1"
    :items-per-page="limit"
    :page="page"
    :footer-props="{
      'items-per-page-options': [5, 10, 15, 20],
    }"
    :hide-default-footer="hideFooter"
    @update:options="updateOptions"
  >
    <template v-if="enableDownload" v-slot:top>
      <div class="d-flex justify-end align-center mx-5 py-2">
        <v-btn
          outlined
          color="#004643"
          @click="bulkDownloadQR"
          style="text-transform: none"
        >
          Download QR
        </v-btn>
        <v-btn
          class="ml-2 white--text text-capitalize"
          color="#004643"
          @click="exportToXLSX"
        >
          Download
        </v-btn>
      </div>
    </template>
    <template v-slot:[slotName]>
      <popup-component></popup-component>
    </template>
    <template v-slot:[`item.total_repairs`]="{ item }">
      <div
        class="d-inline-flex align-center justify-center"
        :style="{
          backgroundColor: item.total_repairs > 0 ? '#f9bc60  ' : '#acd1c6 ',
          width: '30px',
          height: '30px',
          borderRadius: '50%',
          textAlign: 'center',
          fontWeight: 'bold',
        }"
      >
        {{ item.total_repairs }}
      </div>
    </template>
    <template v-slot:[`item.foto`]="{ item }">
      <v-img
        class="my-2"
        :src="item.foto"
        max-width="100px"
        max-height="100px"
        :style="{ 'border-radius': '10px' }"
      ></v-img>
    </template>
    <template v-slot:[`item.image_url`]="{ item }">
      <v-img
        class="my-2"
        :src="item.image_url"
        max-width="100px"
        max-height="100px"
        :style="{ 'border-radius': '10px' }"
      ></v-img>
    </template>
    <template v-slot:[`item.image_urls`]="{ item }">
      <v-img
        class="my-2"
        :src="item.image_urls?.[0]"
        max-width="100px"
        max-height="100px"
        :style="{ 'border-radius': '10px' }"
      ></v-img>
    </template>
    <template v-slot:[`item.images`]="{ item }">
      <v-img
        class="my-2"
        :src="item?.images?.[0]"
        max-width="100px"
        max-height="100px"
        :style="{ 'border-radius': '10px' }"
      ></v-img>
    </template>
    <template v-slot:[`item.arrow`]="{ item }">
      <router-link :to="item.href" v-if="item.href">
        <v-icon>mdi-chevron-right</v-icon>
      </router-link>
      <router-link to="#" v-else>
        <v-icon>mdi-chevron-right</v-icon>
      </router-link>
    </template>
    <template v-slot:[`item.countdown`]="{ item }">
      <span :class="countdownClass(item.countdown)" class="font-weight-bold">{{
        item.countdown
      }}</span>
    </template>
    <template v-slot:[`item.completedTime`]="{ item }">
      <span class="font-weight-bold" style="color: #004643">{{
        item.completedTime
      }}</span>
    </template>
    <template v-slot:[`item.pilih`]>
      <v-btn class="text-capitalize" color="#004643" height="31" outlined
        >Pilih</v-btn
      >
    </template>
    <template v-slot:[`item.price_of_acquisition`]="{ item }">
      <div v-if="item.price_of_acquisition">
        Rp{{ item.price_of_acquisition.toLocaleString("id-ID") }},-
      </div>
    </template>
    <template v-slot:[`item.download`]="{ item }">
      <v-btn
        class="text-capitalize"
        color="#004643"
        height="31"
        outlined
        @click="item.download()"
        >Download
      </v-btn>
    </template>
    <template v-slot:[`item.scopes`]="{ item }">
      <div class="flex-column py-2">
        <div
          v-for="(scope, idx) in item.scopes"
          :key="idx"
          style="
            background-color: #a2a2a2;
            margin-top: 2px;
            padding: 1px;
            text-align: center;
            color: #ffffff;
            border-radius: 25px;
          "
        >
          {{ scope }}
        </div>
      </div>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <v-btn color="blue" height="31" outlined @click="item.editData()">
        Edit Data
      </v-btn>

      <v-btn
        class="mt-1"
        color="blue"
        height="31"
        outlined
        @click="item.updateScopes()"
      >
        Edit Otorisasi
      </v-btn>

      <v-btn
        class="mt-1"
        color="red"
        height="31"
        outlined
        @click="item.deleteUser()"
      >
        Hapus Akun
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import PopupComponent from "@/components/PopupComponent.vue";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import { monthToYearMonth, formatRupiah } from "@/plugins/helpers";

export default {
  components: {
    PopupComponent,
  },
  methods: {
    countdownClass(countdown) {
      if (countdown.includes("-") && /\d/.test(countdown)) {
        return "red--text";
      } else if (/\d/.test(countdown)) {
        return "yellow--text";
      } else {
        return "black--text";
      }
    },
    async getImageArrayBuffer(imageUrl) {
      const response = await fetch(imageUrl);
      return await response.arrayBuffer();
    },
    async bulkDownloadQR() {
      try {
        const filteredItems = this.items.filter((item) => {
          return Object.values(item).some((val) =>
            String(val).toLowerCase().includes(this.search.toLowerCase())
          );
        });
        const response = await this.$axios.post(
          "/assets/bulk-download-qr",
          {
            asset_ids: filteredItems.map((item) => item.id),
          },
          {
            responseType: "arraybuffer",
          }
        );
        // Format date as dd-mm-yy
        const now = new Date();
        const day = String(now.getDate()).padStart(2, "0");
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const year = String(now.getFullYear()).slice(-2);
        const formattedDate = `${day}-${month}-${year}`;
        const blob = new Blob([response.data], { type: "application/zip" });
        saveAs(blob, `${formattedDate}_${this.items[0]?.category}_QR Code.zip`);
      } catch (error) {
        console.error("Error downloading QR codes:", error);
      }
    },
    async exportToXLSX() {
      const downloadedHeaders = [
        {
          text: "System ID",
          value: "id",
        },
        {
          text: "Kode Registrasi",
          value: "asset_code",
        },
        {
          text: "Nomor Urut Barang",
          value: "asset_number",
        },
        {
          text: "Kode Barang",
          value: "real_asset_code",
        },
        {
          text: "Kode Lokasi",
          value: "location_code",
        },
        {
          text: "Nama Barang",
          value: "asset_name",
        },
        {
          text: "Seksi",
          value: "section",
        },
        {
          text: "Golongan",
          value: "asset_group",
        },
        {
          text: "Bidang",
          value: "asset_field",
        },
        {
          text: "Kelompok",
          value: "asset_classification",
        },
        {
          text: "Sub Kelompok",
          value: "asset_sub_classification",
        },
        {
          text: "Sub Sub Kelompok",
          value: "asset_sub_sub_classification",
        },
        {
          text: "Lokasi",
          value: "asset_location",
        },
        {
          text: "X Awal",
          value: "x_start",
        },
        {
          text: "X Akhir",
          value: "x_end",
        },
        {
          text: "Y Awal",
          value: "y_start",
        },
        {
          text: "Y Akhir",
          value: "y_end",
        },
        {
          text: "Sumber Dana",
          value: "funding_source",
        },
        {
          text: "Nilai Perolehan",
          value: "price_of_acquisition",
        },
        {
          text: "Tahun Perolehan",
          value: "date_of_acquisition",
        },
        {
          text: "Keterangan",
          value: "information",
        },
        {
          text: "Pemilik",
          value: "asset_owner",
        },
        {
          text: "Pengembang",
          value: "asset_developer",
        },
        {
          text: "Pengelola",
          value: "asset_operator",
        },
        {
          text: "Umur Manfaat",
          value: "useful_life_months",
        },
        {
          text: "Sisa Umur Manfaat",
          value: "useful_life_months_remaining",
        },
        {
          text: "Foto",
          value: "foto",
        },
      ];
      // Filter items based on the current search value
      const filteredItems = this.items.filter((item) => {
        return Object.values(item).some((val) =>
          String(val).toLowerCase().includes(this.search.toLowerCase())
        );
      });

      // Create a new workbook and add a worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Add headers
      worksheet.addRow(downloadedHeaders.map((header) => header.text));

      // Add rows
      for (const item of filteredItems) {
        const row = downloadedHeaders
          .filter((header) => header.value !== "foto")
          .map((header) => {
            if (
              ["useful_life_months", "useful_life_months_remaining"].includes(
                header.value
              )
            ) {
              return item[header.value]
                ? monthToYearMonth(item[header.value])
                : "";
            } else if (header.value === "price_of_acquisition") {
              return item[header.value] ? formatRupiah(item[header.value]) : "";
            }
            return item[header.value];
          });
        worksheet.addRow(row);
      }

      console.log(filteredItems);

      // Embed images
      for (let i = 0; i < filteredItems.length; i++) {
        const item = filteredItems[i];
        const imageUrl = item.foto;

        if (imageUrl && imageUrl.startsWith("http")) {
          try {
            // const response = await axios.get(imageUrl, { responseType: 'arraybuffer' });
            const arrayBuffer = await this.getImageArrayBuffer(imageUrl);
            const image = workbook.addImage({
              buffer: arrayBuffer,
              extension: "png", // Or use the appropriate image extension
            });

            // Calculate the position for the image
            const colIndex = downloadedHeaders.findIndex(
              (header) => header.value === "foto"
            );
            const cellAddress = { col: colIndex + 1, row: i + 2 };

            // Add the image to the cell
            worksheet.addImage(image, {
              tl: { col: cellAddress.col - 1, row: cellAddress.row - 1 },
              ext: { width: 100, height: 100 }, // Adjust the size as needed
            });

            // Adjust the column width and row height
            worksheet.getColumn(cellAddress.col).width = 15; // Adjust as needed
            worksheet.getRow(cellAddress.row).height = 75; // Adjust as needed
          } catch (error) {
            console.error("Error loading image:", error);
          }
        }
      }

      // Generate the XLSX file and trigger the download
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        this.fileName
      );
    },
    updateOptions(options) {
      this.$emit("update:page", options.page);
      this.$emit("update:limit", options.itemsPerPage);
    },
  },
  props: {
    slotName: String,
    tableTitle: String,
    headers: Array,
    items: Array,
    search: String,
    hideFooter: {
      type: Boolean,
      default: false,
    },
    enableDownload: {
      type: Boolean,
      default: false,
    },
    fileName: {
      type: String,
      default: "data.xlsx",
    },
    limit: {
      type: Number,
    },
    page: {
      type: Number,
    },
  },
};
</script>

<style>
.v-data-table th {
  white-space: nowrap !important;
}
</style>
